__turbopack_context__.v({
  "btn": "swiperCarousel-module-scss-module__e56IEa__btn",
  "next": "swiperCarousel-module-scss-module__e56IEa__next",
  "prev": "swiperCarousel-module-scss-module__e56IEa__prev",
});
